import React from 'react';
import Configurator from './Configurator.jsx';
import styles from './GroundSelectionConfigurator.styl';
import Image from './ui/features/Image.jsx';
import Button from './ui/button/Button.jsx'
import TableComponent from './ui/features/Table.jsx'
import Popup from './ui/features/Popup/Popup.jsx'
import DropDown from './ui/features/DropDown/DropDown.jsx'
import TextAreaInput from './ui/features/TextArea/TextAreaInput.jsx'
import CheckBoxWithHeader from './ui/features/CheckBoxWithHeader/CheckBoxWithHeader.jsx'
import Input from './ui/features/Input/Input.jsx'
import ImageInput from './ui/features/ImageInput/ImageInput.jsx'
import RadioGroup from './ui/features/RadioGroup/RadioGroup.jsx'
import jQuery from 'jquery'
import { PDFDownloadLink} from '@react-pdf/renderer';
import PDFReport from './ui/PDFCreation/PDFGroundSelectReport'
import GroundLightVersion from './ui/features/Version/GroundLightVersion.jsx'

const disabledState = {
	positionDisabled: true,
	pointNumDisabled: true,
	vertGroundDisabled: true,
	oneGroundDisabled: true,
	circleDiamDisabled: true,
	circleMaterialDisabled: true,
	cornerSectionDisabled: true,
	cornerMaterialDisabled: true,
	horizontalGroundDisabled: true,
	connStripDisabled: true,
	lineSectionDisabled: true,
	lineMaterialDisabled: true,
	listForPrint:[],
	showContent:false,
}

const defaultRadioValur = {
	filterPosition: 'В ряд',
	filterCircleDiam: '16',
	filterCircleMaterial: 'Оцинкованная сталь',
	filterCornerSection: '40x40x4',
	filterCornerMaterial: 'Оцинкованная сталь',
	filterHorizontalGround: '',
	filterOneGround: 3,
	filterConnStrip: 1,
	filterLineSection: '40x4',
	filterLineMaterial: 'Оцинкованная сталь',
}

class GroundSelectionConfigurator extends Configurator {

	//Конструктор
	constructor(props) {
		super(props);
		this.state = {

			filterLength: 0,
			filterNumb: 0,
			filterSection: '',
			filterPointNum: 2,
			filterVertGround: '',

			filterName: '',
			filterAuthor: '',
			filterAddress: '',
			filterDesc: '',
			filterProjectImg: '',
			filterTest: '',

			//Списки
			itemList: [], 										// Подобранные аксессуары
			specList: [], 										// Спецификация оборудования

			mz: false,
			ey: false,

			sectionOptions: [],
			circleDiamOptions: ['14', '16', '18', '20'],
			circleMaterialOptions: ['Оцинкованная сталь', 'Омедненная сталь', 'Нержавеющая сталь'],
			cornerSectionOptions: ['40x40x4', '50x50x4', '50x50x5'],
			cornerMaterialOptions: ['Оцинкованная сталь'],
			horizontalGroundOptions: ['3', '12', '28', '42'],
			positionOptions: ['В ряд', 'По контуру'],
			lineSectionOptions: ['40x4', '50x4', '50x5', '25x4'],
			lineMaterialOptions: ['Оцинкованная сталь'],

			showAdditionVoltInfo: false,
			showAdditionConnStripInfo: false,
			showAdditionPositionInfo: false,

			vertSect: 'circle',
			viewSect: 'count',
			warningText:'',

			pointNumMin: 1,
			vertGroundMin: 1,

			...disabledState,
			...defaultRadioValur,
			showLoader:false,

			showWarn:false,

		}

		//Кнопки
		this.doPrint = this.doPrint.bind(this);
		this.onClearFiltersClick = this.onClearFiltersClick.bind(this);
		this.onBtnSaveClick = this.onBtnSaveClick.bind(this);
		this.onExcelBtnClick = this.onExcelBtnClick.bind(this);

		this.addBlock = this.addBlock.bind(this);
		this.infoInput = this.infoInput.bind(this);
		this.groundTypeBlocks = this.groundTypeBlocks.bind(this);
		this.positionBlocks = this.positionBlocks.bind(this);
		this.pointNumBlocks = this.pointNumBlocks.bind(this);
		this.verticalSectionBlocks = this.verticalSectionBlocks.bind(this);
		this.circleFilters = this.circleFilters.bind(this);
		this.cornerFilters = this.cornerFilters.bind(this);
		this.lineHorFilters = this.lineHorFilters.bind(this);
		this.horizontalSectionBlocks = this.horizontalSectionBlocks.bind(this);

		this.onMzChange = this.onMzChange.bind(this);
		this.onEyChange = this.onEyChange.bind(this);
		this.onPositionChange = this.onPositionChange.bind(this);
		this.onPointNumChange = this.onPointNumChange.bind(this);
		this.onPointNumBlur 	= this.onPointNumBlur.bind(this);
		this.onVertGroundChange = this.onVertGroundChange.bind(this);
		this.onVertGroundBlur = this.onVertGroundBlur.bind(this);
		this.onOneGroundChange = this.onOneGroundChange.bind(this);
		this.onOneGroundBlur = this.onOneGroundBlur.bind(this);
		this.onCircleDiamChange = this.onCircleDiamChange.bind(this);
		this.onCircleMaterialChange = this.onCircleMaterialChange.bind(this);
		this.onCornerSectionChange = this.onCornerSectionChange.bind(this);
		this.onCornerMaterialChange = this.onCornerMaterialChange.bind(this);
		this.onHorizontalGroundChange = this.onHorizontalGroundChange.bind(this);
		this.onHorizontalGroundBlur = this.onHorizontalGroundBlur.bind(this);
		this.onConnStripChange = this.onConnStripChange.bind(this);
		this.onConnStripBlur = this.onConnStripBlur.bind(this);
		this.onLineSectionChange = this.onLineSectionChange.bind(this);
		this.onLineMaterialChange = this.onLineMaterialChange.bind(this);

		this.onNameChange = this.onNameChange.bind(this);
		this.onAuthorChange = this.onAuthorChange.bind(this);
		this.onAddressChange = this.onAddressChange.bind(this);
		this.onDescChange = this.onDescChange.bind(this);
		this.onProjectImgChange = this.onProjectImgChange.bind(this);

		// Служебные процедуры и функции
		this.getChangeFromType 			= this.getChangeFromType.bind(this);
		this.getBlurFromType 				= this.getBlurFromType.bind(this);
		this.getOptionsFromType 		= this.getOptionsFromType.bind(this);
		this.getFilterFromType 			= this.getFilterFromType.bind(this);
		this.getDisablesState 			= this.getDisablesState.bind(this);
		this.getItemList 						= this.getItemList.bind(this);
		this.getItem 								= this.getItem.bind(this)
		this.getItemFeature 				= this.getItemFeature.bind(this)
		this.getMatCodeFromStr 			= this.getMatCodeFromStr.bind(this);
		this.getNumFromArt 					= this.getNumFromArt.bind(this);
		this.showWarning 						= this.showWarning.bind(this);
		this.closeWarning 					= this.closeWarning.bind(this);
		this.clickAwayHandler 			= this.clickAwayHandler.bind(this);

		this.vertSecCircle = this.vertSecCircle.bind(this);
		this.vertSecCorner = this.vertSecCorner.bind(this);
		this.viewSecCount = this.viewSecCount.bind(this);
		this.viewSecResult = this.viewSecResult.bind(this);

		this.onInputChange = this.onInputChange.bind(this)
		this.filterItemList 								= this.filterItemList.bind(this);

		this.changeNextStates = this.changeNextStates.bind(this)
		this.onNavConfigurator = this.onNavConfigurator.bind(this)
		this.onDocConfigurator = this.onDocConfigurator.bind(this)

		// Обработка событий таблиц
		this.onChangeQuantity 							= this.onChangeQuantity.bind(this);
		this.addBasket 											= this.addBasket.bind(this);
		this.onDelete 											= this.onDelete.bind(this);
	}

	componentDidMount() {
		this.loadDb()
	}

	loadDb() {
		jQuery.getJSON(
			'itkcfg.php',
			{
				type: this.getType(),
				action: 'get'
			},
			db => {
				this.db = db;
				this.getItemList()
			}
		);
	}

	getItem(article){
		return jQuery.getJSON(
			'itkcfg.php',
			{
				type: this.getType(),
				action: 'getItemNSI',
				article: article
			},
			itemInfo => itemInfo)
	}

	getItemFeature(article){
		return jQuery.getJSON(
			'itkcfg.php',
			{
				type: this.getType(),
				action: 'getItemEtimNSI',
				article: article,
				groupId: '05.08'
			},
			itemInfo => itemInfo)
	}

	// ++ Для Запуска
	getCustomStyles() {
		return styles;
	}

	getType() {
		return 'ground_select';
	}

	// -- Для Запуска

	// ++Кнопки
	getCustomButtons() {
		let elements = [];

		elements.push(
			<Button
				x="20"
				y="710"
				buttonStyle={styles.buttonClearAll}
				textStyle={styles.mainBtnText}
				iconStyle={styles.buttonClearAllIcon}
				text="Сбросить фильтр"
				onClick={this.onClearFiltersClick}
				key="clearAll"
			/>
		);

		elements.push(
			<Button
				x="250"
				y="710"
				buttonStyle={styles.mainBtn}
				textStyle={styles.mainBtnText}
				iconStyle={styles.pdfBtnIcon}
				text="Главное меню"
				onClick={this.onNavConfigurator}
				key="backToNav"
			/>
		);

		if (this.state.listForPrint.length && this.state.viewSect === 'result'){
			elements.push(
				<PDFDownloadLink key={'pdf'} document={<PDFReport
					date={new Date().toLocaleDateString()}
					name={this.state.filterName}
					address={this.state.filterAddress}
					shortDesc={this.state.filterDesc ? this.state.filterDesc.substr(0,100) : null}
					desc={this.state.filterDesc}
					author={this.state.filterAuthor}
					position={this.state.filterPosition}
					vertGround={this.state.filterVertGround}
					vDiamType = {this.state.vertSect === 'circle' ? 'Диаметр, мм: ' : 'Сечение, мм: ' }
					vDiam={this.state.vertSect === 'circle' ? this.state.filterCircleDiam : this.state.filterCornerSection }
					vLength={this.state.filterOneGround}
					vMaterial={this.state.vertSect === 'circle' ? this.state.filterCircleMaterial : this.state.filterCornerMaterial}
					hSection={this.state.filterLineSection}
					hLength={this.state.filterHorizontalGround}
					hMaterial={this.state.filterLineMaterial}
					points={this.state.filterPointNum}
					imgData={this.state.filterProjectImg}
					pasportList={this.state.listForPrint}
					listForTable={this.state.specList}

				/>} fileName="Отчет.pdf"
												 style={{
													 position: 'absolute',
													 top:'710px',
													 left:'480px',
												 }}>

					<div className={styles.mainBtn} title={'Скачать отчет pdf'}>
						{styles.pdfBtnIcon &&
							<div className={styles.pdfBtnIcon}></div>
						}
						<span className={styles.mainBtnText}>{'Скачать отчет pdf'}</span>
					</div>
				</PDFDownloadLink>
			)

			elements.push(
				<Button
					x="710"
					y="710"
					buttonStyle={styles.mainBtn}
					textStyle={styles.mainBtnText}
					iconStyle={styles.printBtnIcon}
					text="Спецификация Excel"
					onClick={this.onExcelBtnClick}
					key="print"
				/>
			);
		}

		elements.push(
			<Button
				x="1190"
				y="710"
				buttonStyle={styles.buttonDoc}
				textStyle={styles.mainBtnText}
				iconStyle={styles.pdfBtnIcon}
				text="Нормативно-техническая документация"
				onClick={this.onDocConfigurator}
				key="doc"
			/>
		);

		return elements;
	}

// -- Кнопки

// ++ Обработка событий

// ++ Служебные приоцедуры и функции

	filterItemList() {

		this.setState({
			specList: [],
			showLoader: true,
			viewSect: 'result'
		}, () => {
			let itemList = []
			let speclist = []
			if (this.state.mz || this.state.ey) {

				// Фильтрация coreList
				const mv = this.getMatCodeFromStr(this.state.vertSect === 'circle' ? this.state.filterCircleMaterial : this.state.filterCornerMaterial)
				const dv = this.state.filterCircleDiam
				if (this.state.vertSect === 'circle') {
					let coreList = this.state.coreList
					coreList = coreList.filter(item => item.dv === dv)
					coreList = coreList.filter(item => item.mv === mv)
					speclist = [...speclist, ...coreList]

					// Фильтрация couplerList
					let couplerList = this.state.couplerList
					couplerList = couplerList.filter(item => item.dv === dv)
					couplerList = couplerList.filter(item => item.mv === mv)
					speclist = [...speclist, ...couplerList]

					// Фильтрация couplerDoubleList
					let couplerDoubleList = this.state.couplerDoubleList
					if (mv === 'b') {
						couplerDoubleList = couplerDoubleList.filter(item => item.dv === dv)
						couplerDoubleList = couplerDoubleList.filter(item => item.mv === mv)
						speclist = [...speclist, ...couplerDoubleList]
					} else if (mv === 'd' && dv !== '14') {
						couplerDoubleList = couplerDoubleList.filter(item => Number(item.dv) === Number(dv) - 2)
						speclist = [...speclist, ...couplerDoubleList]
					}

					// Фильтрация tipList
					let tipList = this.state.tipList
					tipList = tipList.filter(item => item.dv === dv)
					tipList = tipList.filter(item => item.mv === mv)
					speclist = [...speclist, ...tipList]

					// Фильтрация tipDoubleList
					let tipDoubleList = this.state.tipDoubleList
					if (mv === 'b') {
						tipDoubleList = tipDoubleList.filter(item => item.dv === dv)
						tipDoubleList = tipDoubleList.filter(item => item.mv === mv)
						speclist = [...speclist, ...tipDoubleList]
					} else if (mv === 'd' && dv !== '14') {
						tipDoubleList = tipDoubleList.filter(item => Number(item.dv) === Number(dv) - 2)
						speclist = [...speclist, ...tipDoubleList]
					}

				} else {
					// Фильтрация cornerList
					let cornerList = this.state.cornerList
					const sv = this.state.filterCornerSection
					cornerList = cornerList.filter(item => item.sv === sv)
					cornerList = cornerList.filter(item => item.mv === mv)
					speclist = [...speclist, ...cornerList]
				}

				const gmat = this.state.filterLineMaterial
				const mg = this.getMatCodeFromStr(gmat)


				// Фильтрация stripeList
				let stripeList = this.state.stripeList
				const sg = this.state.filterLineSection
				// const lg = this.state.filterHorizontalGround
				stripeList = stripeList.filter(item => item.sg === sg)
				stripeList = stripeList.filter(item => item.mg === mg)
				stripeList = stripeList.filter(item => Number(item.pack_l) >= 42)
				speclist = [...speclist, ...stripeList]

				let stripeSpcList = this.state.stripeSpcList
				stripeSpcList = stripeSpcList.filter(item => item.sg === sg)
				stripeSpcList = stripeSpcList.filter(item => item.mg === mg)
				stripeSpcList = stripeSpcList.filter(item => Number(item.pack_l) >= 42)
				speclist = [...speclist, ...stripeSpcList]

				// Фильтрация clipList
				let clipList = this.state.clipList
				clipList = clipList.filter(item => item.mv === mv)
				clipList = clipList.filter(item => item.mg === mg)

				speclist = [...speclist, ...clipList]

				// Фильтрация clipCrossList

				let clipCrossList = this.state.clipCrossList
				clipCrossList = clipCrossList.filter(item => item.mg === mg)
				clipCrossList = clipCrossList.filter(item => (item.mv === mv) || (item.mg === 'e' && !item.mv && mv !== 'c'))
				speclist = [...speclist, ...clipCrossList]

				// Фильтрация holderList
				let holderList = mg === 'a' ? this.state.holderList : []
				speclist = [...speclist, ...holderList]

				// Добавляем drill List
				itemList = [...itemList, ...this.state.drillList]

				// Фильтрация headList
				let headList = this.state.headList
				if (mv === 'b') {
					headList = headList.filter(item => item.dv === dv)
					headList = headList.filter(item => item.mv === mv)
					itemList = [...itemList, ...headList]
				} else if (dv !== '14') {
					headList = headList.filter(item => Number(item.dv) === Number(dv) - 2)
					itemList = [...itemList, ...headList]
				}

				// Добавляем isolStripeList
				itemList = [...itemList, ...this.state.isolStripeList]

				// Добавляем dopeList
				itemList = [...itemList, ...this.state.dopeList]

				// Фильтрация bolderBarList
				let bolderBarList = this.state.bolderBarList
				bolderBarList = bolderBarList.filter(item => item.mv === mg)
				itemList = [...itemList, ...bolderBarList]
			}

			const articles = speclist.map(item => item.article.trim())
			const idPromise = articles.map(this.getItem)
			const allProgucts = Promise.all(idPromise)
			let list
			let featureObj

			allProgucts.then(res => {
				list = res.map(item => {
					if (!item.length) return ''
					return {
						article: item[0].art,
						name: item[0].name,
						desc: item[0].Description[0].desc_ru,
						url: item[0].ImgPng[0].file_ref.uri,
					}
				})
				list = list.filter(Boolean)

			}).then(() => {
				const featurePromise = articles.map(this.getItemFeature)
				return Promise.all(featurePromise)
			}).then(featureArr => {
				featureArr = featureArr.filter(item => item.length)
				featureArr.map(item => {
					let features = item[0].Features.filter(fitItemForFill => !fitItemForFill.Attribute.includes('_Name')
						&& !fitItemForFill.Attribute.includes('_Code')
						&& !(fitItemForFill.value === '-')
						&& !fitItemForFill.Attribute.includes('ChangeTrackingMask'))
						.map(featureItem => {
							return {
								Attribute: featureItem.unit ? featureItem.Attribute.split(' ').slice(0, -1).join(' ') : featureItem.Attribute,
								unit: featureItem.unit ? featureItem.unit : '',
								value: featureItem.value,
							}
						})
					features = this.delDuplicatesFromArray(features)

					featureObj = {
						...featureObj,
						[item[0].Code]: features
					}
				})
				list = list.map(item => {
					return {
						...item,
						features: featureObj[item.article]
					}
				})

				const specList = []

				speclist.map(item => {
					if (specList.some(i => i.article === item.article)) {
						specList.map(i => {
							if (i.article === item.article) {
								i.count = Number(i.count) + Number(this.getNumFromArt(i))
							}
							return i
						})
					} else {
						item.count = this.getNumFromArt(item)
						item.disable = true
						specList.push(item)
					}
				})

				this.setState({
					listForPrint: list,
					showLoader: false,
					specList
				})

			})

			this.setState({
				itemList,
			})
		})

	}

	getMatCodeFromStr(matStr){
		switch (matStr){
			case 'Оцинкованная сталь': return 'a'
			case 'Омедненная сталь': return 'b'
			case 'Нержавеющая сталь': return 'c'
			case 'Латунь': return 'd'
			case 'Медь':  return 'e'
		}

	}

	getItemList(){
		const newArr = this.db.list.reduce((counter, item) =>{
			if(item.type === 'core') 							counter.coreList.push(item)
			if(item.type === 'coupler') 					counter.couplerList.push(item)
			if(item.type === 'tip') 							counter.tipList.push(item)
			if(item.type === 'corner') 						counter.cornerList.push(item)
			if(item.type === 'clip') 							counter.clipList.push(item)
			if(item.type === 'stripe') 						counter.stripeList.push(item)
			if(item.type === 'clip_cross') 				counter.clipCrossList.push(item)
			if(item.type === 'holder') 						counter.holderList.push(item)
			if(item.type === 'drill') 						counter.drillList.push(item)
			if(item.type === 'head') 							counter.headList.push(item)
			if(item.type === 'isol_stripe') 			counter.isolStripeList.push(item)
			if(item.type === 'dope') 							counter.dopeList.push(item)
			if(item.type === 'bolder_bar') 				counter.bolderBarList.push(item)
			if(item.type === 'coupler_double') 		counter.couplerDoubleList.push(item)
			if(item.type === 'tip_double') 				counter.tipDoubleList.push(item)
			if(item.type === 'stripe_spc') 				counter.stripeSpcList.push(item)
			return counter
		},{
			coreList:[],
			couplerList:[],
			tipList:[],
			cornerList:[],
			clipList:[],
			stripeList:[],
			clipCrossList:[],
			holderList:[],
			drillList:[],
			headList:[],
			isolStripeList:[],
			dopeList:[],
			bolderBarList:[],
			couplerDoubleList:[],
			tipDoubleList:[],
			stripeSpcList:[]
		})
		this.setState({
			coreList:newArr.coreList,
			couplerList:newArr.couplerList,
			tipList:newArr.tipList,
			cornerList:newArr.cornerList,
			clipList:newArr.clipList,
			stripeList:newArr.stripeList,
			clipCrossList:newArr.clipCrossList,
			holderList:newArr.holderList,
			drillList:newArr.drillList,
			headList:newArr.headList,
			isolStripeList:newArr.isolStripeList,
			dopeList:newArr.dopeList,
			bolderBarList:newArr.bolderBarList,
			couplerDoubleList:newArr.couplerDoubleList,
			tipDoubleList:newArr.tipDoubleList,
			stripeSpcList:newArr.stripeSpcList,
		})
	}

	getFilterFromType(type) {
		return 'filter' + this.capitalizeFirstLetter(type)
	}

	getOptionsFromType(type) {
		return type + 'Options'
	}

	getChangeFromType(type) {
		return 'on' + this.capitalizeFirstLetter(type) + 'Change'
	}

	getBlurFromType(type) {
		return 'on' + this.capitalizeFirstLetter(type) + 'Blur'
	}

	getDisablesState(type) {
		return type + 'Disabled'
	}

// -- Служебные приоцедуры и функции

// ++ Кнопки
	onClearFiltersClick() {
		this.setState({
			itemList:[],
			...disabledState,
			...defaultRadioValur,
			viewSect:'count',
			mz:false,
			ey:false,
			specList:[]
		})
	}

	onExcelBtnClick(){
		this.doPrint({format: 'xls'});
	}

	onNavConfigurator() {
		if (this.props.onNavConfigurator) {
			this.props.onNavConfigurator();
		}
	}

	onDocConfigurator() {
		if (this.props.onDocConfigurator) {
			this.props.onDocConfigurator();
		}
	}

// -- Кнопки

// ++ Дропдауны
	onCircleDiamChange(event) {
		const value = event.target.value
		this.setState({
			filterCircleDiam: value,
		})
	}

	onCircleMaterialChange(event) {
		const value = event.target.value

		let stateObj = {filterCircleMaterial: value}

		const material = value === 'Оцинкованная сталь' ? 'Оцинкованная сталь' : 'Медь'

		stateObj = {
			...stateObj,
			lineMaterialOptions: [material],
			filterLineMaterial:material,
		}

		this.setState({
			...stateObj
		})
	}

	onCornerSectionChange(event) {
		const value = event.target.value
		this.setState({
			filterCornerSection: value,
		})
	}

	onCornerMaterialChange(event) {
		const value = event.target.value
		let stateObj = {filterCornerMaterial: value}
		const material = value === 'Оцинкованная сталь' ? 'Оцинкованная сталь' : 'Медь'

		stateObj = {
			...stateObj,
			lineMaterialOptions: [material],
			filterLineMaterial:material,
		}
		this.setState({
			...stateObj
		})
	}

	onLineSectionChange(event) {
		const value = event.target.value
		this.setState({
			filterLineSection: value,
		})
	}

	onLineMaterialChange(event) {
		const value = event.target.value
		this.setState({
			filterLineMaterial: value,
		})
	}

// -- Дропдауны

// ++ Инпуты
	onInputChange(value, type) {
		this.setState({[this.getFilterFromType(type)]: value})
	}

	onPointNumChange(event) {

		this.setState({filterPointNum: event.target.value})

	}

	onPointNumBlur(event) {

		let value = event.target.value
		if(this.state.mz && value < 2) {
			this.showWarning('При выборе заземляющего устройства для молниезащиты минимальное количество точек присоедиинения к контуру равно 2')
			this.setState({
				filterPointNum: 2,
			})
			return
		}
		this.setState({
			filterPointNum: value,
		})

	}

	onVertGroundChange(event) {

		let value = event.target.value

		if (((this.state.filterHorizontalGround < value * this.state.filterOneGround)
				&& this.state.filterPosition === 'По контуру')
			|| ((this.state.filterHorizontalGround < (value - 1) * this.state.filterOneGround)
			&& this.state.filterPosition === 'В ряд')
			&& this.state.filterHorizontalGround !== ''
		) {
			this.showWarning('Расстояние между вертикальными заземлителями не может быть меньше длины одного вертикального заземлителя.')
			this.setState({
				filterHorizontalGround: '',
				filterVertGround: value
			})
			return
		}

		this.setState({filterVertGround: value})
	}

	onVertGroundBlur(event) {

		const value = event.target.value

		if( this.state.mz && value < 2){
			this.setState({
				filterVertGround: '',
			})
			return
		}

		if( !this.state.mz && value < 1){
			this.setState({
				filterVertGround: '',
			})
			return
		}

		this.setState({
			filterVertGround: value,
		})

	}

	onOneGroundChange(event) {

		let value = event.target.value

		if (((this.state.filterHorizontalGround < this.state.filterVertGround * value)
				&& this.state.filterPosition === 'По контуру')
			|| ((this.state.filterHorizontalGround < (this.state.filterVertGround - 1) * value)
			&& this.state.filterPosition === 'В ряд')
			&& this.state.filterHorizontalGround !== ''
		) {
			this.showWarning('Расстояние между вертикальными заземлителями не может быть меньше длины одного вертикального заземлителя.')
			this.setState({
				filterOneGround: value,
				filterHorizontalGround: ''
			})
			return
		}

		this.setState({
			filterOneGround: value,
		})
	}

	onOneGroundBlur(event) {
		const value = event.target.value

		let result = value
		if(value <= 3) {
			result = 3
		}	else if(value > 3 && value <= 4.5 ){
			result = 4.5
		} else if(value > 4.5 && value <= 6 ){
			result = 6
		} else if(value > 6 && value <= 7.5 ){
			result = 7.5
		} else if(value > 7.5 && value <= 9 ){
			result = 9
		} else if(value > 9 && value <= 10.5 ) {
			result = 10.5
		} else if(value > 10.5 && value <= 12 ) {
			result = 12
		} else if(value > 12 ){
			this.showWarning('Введите значенине не более 12 метров')
			result = 12
		}

		if (value > 3 && this.state.vertSect === 'corner') {
			this.showWarning('Выберите длину вертикального заземлителя 3 либо выберите "КРУГ", так как уголки длинной по 3 метра')
			this.setState({
				filterOneGround:result,
				filterHorizontalGround: '',
			})
			return
		}

		if (value < 3) {
			this.setState({
				filterOneGround:3,
			})
			return
		}

		this.setState({
			filterOneGround:result,
		})
	}

	onHorizontalGroundChange(event) {
		this.setState({
			filterHorizontalGround: event.target.value,
		})
	}

	onHorizontalGroundBlur(event) {
		const value = event.target.value

		if ((((value < this.state.filterVertGround*this.state.filterOneGround)
				&& this.state.filterPosition === 'По контуру')
			|| (value < (this.state.filterVertGround-1)*this.state.filterOneGround)
			&& this.state.filterPosition === 'В ряд')
			&& this.state.filterHorizontalGround !== ''
		) {
			this.showWarning('Введите большее значение. Расстояние между вертикальными заземлителями не может быть меньше длины одного вертикального заземлителя.')
			this.setState({
				filterHorizontalGround: ''
			})
			return
		}

		if(value < 3){
			this.setState({
				filterHorizontalGround: 3,
			})
			return
		}

		this.setState({
			filterHorizontalGround: value,
		})
	}

	onConnStripChange(event) {
		this.setState({filterConnStrip: event.target.value})
	}

	onConnStripBlur(event) {
		const value = event.target.value
		if(value < 1){
			this.setState({filterConnStrip: 1})
			return
		}

		this.setState({filterConnStrip: value})
	}

	onNameChange(event){
		this.setState({filterName: event.target.value})
	}

	onAuthorChange(event){
		this.setState({filterAuthor: event.target.value})
	}

	onAddressChange(event){
		this.setState({filterAddress: event.target.value})
	}

	onDescChange(event){
		this.setState({filterDesc: event.target.value})
	}

	onProjectImgChange(event){
		const fReader = new FileReader();
		fReader.readAsDataURL(event.target.files[0]);
		fReader.onloadend = (e) =>{
			this.setState({
				filterProjectImg:e.target.result
			})
		}
	}

// -- Инпуты

// ++ Чекбоксы
	onMzChange(event) {
		const value = event.target.checked
		const inputMin = value ? 2 : 1
		let lineSectionOptions = this.state.lineSectionOptions

		value ? lineSectionOptions.pop() : lineSectionOptions.push('25x4')

		this.setState({
			mz: value,
			pointNumMin: inputMin,
			vertGroundMin: inputMin,
			filterPointNum: this.state.filterPointNum > 2 ? this.state.filterPointNum : 2,
			filterVertGround: this.state.filterVertGround > 1 ? this.state.filterVertGround : '',
			lineSectionOptions,
		}, () => this.changeNextStates())
	}

	onEyChange(event) {
		const value = event.target.checked

		let stateObj = {ey: value}

		if (!value) {
			stateObj = {
				filterPointNum: this.state.filterPointNum > 2 ? this.state.filterPointNum : 2,
				filterVertGround: this.state.filterVertGround > 1 ? this.state.filterVertGround : '',
				...stateObj
			}
		}

		this.setState({
			...stateObj
		}, () => this.changeNextStates())
	}

// -- Чекбоксы

// ++ Радио
	onPositionChange(event) {

		this.setState({
			filterPosition: event.target.value,
		}, () => {
			this.changeNextStates()
		})

	}

// --	Радио

// ++ Табы
	vertSecCircle() {

		if (this.state.vertSect === 'circle') return

		this.setState({
			vertSect: 'circle',
			filterCornerSection: '40x40x4',
			filterCornerMaterial: 'Оцинкованная сталь',
			filterLineMaterial: 'Оцинкованная сталь',
			lineMaterialOptions: ['Оцинкованная сталь'],
		})
	}

	vertSecCorner() {

		if (this.state.vertSect === 'corner') return
		if (this.state.filterOneGround > 3) {
			this.showWarning('Выберите длину вертикального заземлителя 3 либо либо выберите "КРУГ", так как уголки длинной по 3 метра')
			return
		}

		this.setState({
			vertSect: 'corner',
			filterCircleDiam: '16',
			filterCircleMaterial: 'Оцинкованная сталь',
			filterLineMaterial: 'Оцинкованная сталь',
			lineMaterialOptions: ['Оцинкованная сталь'],
		})
	}

	viewSecCount(){
		if (this.state.viewSect === 'count') return
		this.setState({
			viewSect:'count',
			specList:[],
			itemList:[]
		})
	}

	viewSecResult(){

		if (this.state.viewSect === 'result') return
		if (!this.state.mz && !this.state.ey){
			this.showWarning('Выберите вид заземляющего устройства');
			return
		}

		if (!this.state.filterHorizontalGround){
			this.showWarning('Введите длину горизонтального заземлеителя');
			return
		}

		if (!this.state.filterVertGround){
			this.showWarning('Введите количество вертикальных заземлеителей');
			return
		}

		this.filterItemList()
	}

	changeNextStates() {

		let resultObj = {
			showContent:true,
			positionDisabled: false,
			pointNumDisabled: false,
			vertGroundDisabled: false,
			oneGroundDisabled: false,
			circleDiamDisabled: false,
			circleMaterialDisabled: false,
			cornerSectionDisabled: false,
			cornerMaterialDisabled: false,
			connStripDisabled: false,
			lineSectionDisabled: false,
			lineMaterialDisabled: false,
			horizontalGroundDisabled: false,

			filterPosition: this.state.filterPosition,
			filterCircleDiam: this.state.filterCircleDiam,
			filterCircleMaterial: this.state.filterCircleMaterial,
			filterCornerSection: this.state.filterCornerSection,
			filterCornerMaterial: this.state.filterCornerMaterial,
			filterHorizontalGround: this.state.filterHorizontalGround,
			filterOneGround: this.state.filterOneGround,
			filterConnStrip: this.state.filterConnStrip,
			filterLineSection: this.state.filterLineSection,
			filterLineMaterial: this.state.filterLineMaterial,
		}

		if (!this.state.mz && !this.state.ey) {
			resultObj = {
				...disabledState,
				...defaultRadioValur,
			}
		}

		this.setState({
			...resultObj
		})

	}

// -- Табы

	// ++ Работа таблиц
	//Отображение выбранного значения
	onListItemCheck(item) {
		super.onListItemCheck(item.article)
	}

	addBasket(item) {

		const specList = this.state.specList

		let list = []

		if (specList.some(i => i.article === item.article)) {
			specList.map(i => {
				if(i.article === item.article) {
					i.count = Number(i.count) + Number(this.getNumFromArt(i))
				}
				return i
			})

			this.setState({
				specList
			})

		} else {
			this.setState({
				showLoader:true
			}, () => {
				this.getItem(item.article)
					.then(data => {
						list.push({
							article: data[0].art,
							name: data[0].name,
							desc: data[0].Description[0].desc_ru,
							url: data[0].ImgPng[0].file_ref.uri,
						})
					}).then(() => this.getItemFeature(item.article))
					.then(featureItem => {
						let features = featureItem[0].Features.filter(fitItemForFill => !fitItemForFill.Attribute.includes('_Name')
							&& !fitItemForFill.Attribute.includes('_Code')
							&& !(fitItemForFill.value === '-')
							&& !fitItemForFill.Attribute.includes('ChangeTrackingMask'))
							.map(featureItem => {
								return {
									Attribute: featureItem.unit ? featureItem.Attribute.split(' ').slice(0, -1).join(' ') : featureItem.Attribute,
									unit: featureItem.unit ? featureItem.unit : '',
									value: featureItem.value,
								}
							})
						features = this.delDuplicatesFromArray(features)

						list = list.map(item => {
							return {
								...item,
								features
							}
						})
						item = {...item, count: this.getNumFromArt(item)}
						this.setState({
							listForPrint: [...this.state.listForPrint, ...list],
							specList:[...this.state.specList, item],
							showLoader:false
						})
					})
			})

		}

	}

	showWarning(warningText){
		this.setState({
			showWarn: true,
			warningText
		})
	}

	clickAwayHandler(event){
		this.closeWarning()
	}

	closeWarning(){
		this.setState({showWarn: false})
	}

	getNumFromArt(item){
		const {type, pack_l} = item
		switch(type){
			case 'core': return (this.state.filterVertGround * this.state.filterOneGround)/1.5
			case 'coupler_double':
			case 'coupler': return (((this.state.filterOneGround/1.5)-1) * this.state.filterVertGround)
			case 'tip':
			case 'tip_double':
			case 'clip':
			case 'corner': return this.state.filterVertGround
			case 'clip_cross': return Math.ceil(Number(this.state.filterPointNum) + (this.state.filterHorizontalGround / 42))
			case 'stripe':
			case 'rod':return Math.ceil(this.state.filterHorizontalGround/pack_l)
			case 'stripe_spc':
				return Math.ceil((Number(this.state.filterHorizontalGround) + (Number(this.state.filterPointNum)*(Number(this.state.filterConnStrip)+2)))/pack_l)
			case 'holder': return this.state.filterPointNum
			default: return 1
		}
	}

	//Удаление
	onDelete(item) {
		this.setState((prevState) => {
			return {
				...prevState,
				specList: prevState.specList.filter((el) => el.article !== item.article),
				listForPrint: prevState.listForPrint.filter((el) => el.article !== item.article)
			}
		})

	}

	// изменение количества позиции
	onChangeQuantity(item, value) {

		this.setState(prevState => {
			const newBasket = prevState.specList.map(i => {
				if (i.article === item.article) {
					i.count = value
				}
				return i
			})
			return {
				specList: newBasket,
			}
		})
	}

	// -- Работа таблиц

// --	Обработка событий

// ++ Рендер
	addBlock() {
		let elements = [];

		elements.push(...this.groundTypeBlocks())
		if(this.state.showContent){
			elements.push(...this.positionBlocks())
			elements.push(...this.pointNumBlocks())
			elements.push(...this.verticalSectionBlocks())
			elements.push(...this.horizontalSectionBlocks())
			elements.push(...this.lineHorFilters())
		}
		return elements
	}

	groundTypeBlocks() {
		let elements = [];

		elements.push(<div key={'ground' + elements.length} className={styles.sectionTitle}
											 style={{top: '180px', left: '420px'}}> Шаг 1. Вид заземляющего устройства (по назначению)</div>)

		elements.push(<div key={'ground' + elements.length}>
		<span className={styles.positionInfo}
					onPointerEnter={() => this.setState({showAdditionPositionInfo: true})}
					onPointerLeave={() => this.setState({showAdditionPositionInfo: false})}>&#63;</span>
			{this.state.showAdditionPositionInfo
				&& <span className={styles.showPositionInfo}>
					К заземлителям для электрических установок и молниезащиты предъявляются разные
					требования. Для молниезащиты конструктив заземлителей нормируется «Инструкцией по
					молниезащите РД 34.21.122-87», а для электрических установок — «Правилами устройства
					электроустановок (ПУЭ)</span>}
		</div>)

		elements.push(<CheckBoxWithHeader
				x={416}
				y={210}
				labelX={445}
				labelY={215}
				widthLbl={180}
				title='Для молниезащиты'
				key={'ground' + elements.length}
				onChange={this[this.getChangeFromType('mz')]}
				value={this.state.mz}
				type='mz'
			/>
		)
		elements.push(<CheckBoxWithHeader
				x={640}
				y={210}
				labelX={670}
				labelY={215}
				widthLbl={195}
				title='Для электрических установок'
				key={'ground' + elements.length}
				onChange={this[this.getChangeFromType('ey')]}
				value={this.state.ey}
				type='ey'
			/>
		)

		return elements
	}

	positionBlocks() {
		let elements = [];
		elements.push(<div key={'position' + elements.length} className={styles.sectionTitle}
											 style={{top: '250px', left: '420px'}}>Шаг 2. Расположение заземлителей</div>)
		elements.push(<RadioGroup
			key={'position' + elements.length}
			type='position'
			x={416}
			y={280}
			options={this.state[this.getOptionsFromType('position')]}
			value={this.state[this.getFilterFromType('position')]}
			onChange={this[this.getChangeFromType('position')]}
			disabled={this.state[this.getDisablesState('position')]}
		/>)

		return elements
	}

	pointNumBlocks() {
		let elements = [];

		elements.push(<div key={'pointNum' + elements.length} className={styles.sectionTitle}
											 style={{top: '320px', left: '420px'}}>Шаг. 3 Вертикальный заземлитель</div>)

		elements.push(<Input
			key={'pointNum' + elements.length}
			x={420}
			y={352}
			title='Количество вертикальных заземлителей'
			type = 'number'
			min={this.state.vertGroundMin}
			max={999}
			step={1}
			onChange={this[this.getChangeFromType('vertGround')]}
			onBlur={this[this.getBlurFromType('vertGround')]}
			disabled={this.state[this.getDisablesState('vertGround')]}
			value={this.state[this.getFilterFromType('vertGround')]}
		/>)

		elements.push(<Input
			key={'pointNum' + elements.length}
			x={420}
			y={410}
			title='Длина одного вертикального заземлителя'
			type = 'number'
			min={3}
			max={12}
			step={1.5}
			onChange={this[this.getChangeFromType('oneGround')]}
			onBlur={this[this.getBlurFromType('oneGround')]}
			disabled={this.state[this.getDisablesState('oneGround')]}
			value={this.state[this.getFilterFromType('oneGround')]}
		/>)

		return elements
	}

	verticalSectionBlocks() {

		let elements = [];

		let circleBGColor = this.state.vertSect === 'circle' ? '#E6EFF1' : '#dcdcdc'
		let cornerBGColor = this.state.vertSect === 'circle' ? '#dcdcdc' : '#E6EFF1'

		elements.push(<div
			key={'vertSec' + elements.length}
			style={{position: 'absolute', top: '352px', left: "700px"}}>
			<span
				onClick={this.vertSecCircle}
				style={{background: circleBGColor, cursor:'pointer'}}
				className={styles.circleSectionTitle + ' ' + 'activeTab'}>Круг</span>
			<span
				onClick={this.vertSecCorner}
				style={{background: cornerBGColor, cursor:'pointer'}}
				className={styles.cornerSectionTitle + ' ' + 'activeTab'}>Уголок</span>
		</div>)

		const filters = this.state.vertSect === 'circle' ? this.circleFilters() : this.cornerFilters()
		elements.push(...filters)

		elements.push(<div style={{
			position: 'absolute',
			top: '382px',
			left: '700px',
			margin: '0 auto',
			backgroundColor: '#E6EFF1',
			width: '380px',
			height: '70px',
			zIndex: '1'
		}}
			key={'vertSec' + elements.length}/>)

		return elements
	}

	circleFilters() {

		let elements = [];

		elements.push(<DropDown
			x={715}
			y={395}
			title='Диаметр, мм:'
			key={'circle' + elements.length}
			onChange={this[this.getChangeFromType('circleDiam')]}
			disabled={this.state[this.getDisablesState('circleDiam')]}
			value={this.state[this.getFilterFromType('circleDiam')]}
			options={this.state[this.getOptionsFromType('circleDiam')]}
		/>)

		elements.push(<DropDown
			x={915}
			y={395}
			title='Материал:'
			key={'circle' + elements.length}
			onChange={this[this.getChangeFromType('circleMaterial')]}
			disabled={this.state[this.getDisablesState('circleMaterial')]}
			value={this.state[this.getFilterFromType('circleMaterial')]}
			options={this.state[this.getOptionsFromType('circleMaterial')]}
		/>)

		return elements

	}

	cornerFilters() {
		let elements = [];

		elements.push(<DropDown
			x={715}
			y={395}
			title='Сечение, мм:'
			key={'corner' + elements.length}
			onChange={this[this.getChangeFromType('cornerSection')]}
			disabled={this.state[this.getDisablesState('cornerSection')]}
			value={this.state[this.getFilterFromType('cornerSection')]}
			options={this.state[this.getOptionsFromType('cornerSection')]}
		/>)

		elements.push(<DropDown
			x={915}
			y={395}
			title='Материал:'
			key={'corner' + elements.length}
			onChange={this[this.getChangeFromType('cornerMaterial')]}
			disabled={this.state[this.getDisablesState('cornerMaterial')]}
			value={this.state[this.getFilterFromType('cornerMaterial')]}
			options={this.state[this.getOptionsFromType('cornerMaterial')]}
		/>)

		return elements
	}

	horizontalSectionBlocks() {

		let elements = [];

		elements.push(<div key={'horizontal' + elements.length} className={styles.sectionTitle}
											 style={{top: '475px', left: '420px'}}>Шаг. 4 Горизонтальный заземлитель</div>)

		elements.push(<Input
				x={420}
				y={505}
				title='Длина горизонтального заземлителя, м:'
				key={'horizontal' + elements.length}
				type = 'number'
				min={3}
				max={1000}
				step={1}
				onChange={this[this.getChangeFromType('horizontalGround')]}
				disabled={this.state[this.getDisablesState('horizontalGround')]}
				onBlur={this[this.getBlurFromType('horizontalGround')]}
				value={this.state[this.getFilterFromType('horizontalGround')]}
			/>)

		elements.push(<Input
			key={'horizontal' + elements.length}
			x={420}
			y={565}
			title='Расстояние от здания до контура заземления, м:'
			type = 'number'
			min={1}
			max={10}
			step={0.1}
			onChange={this[this.getChangeFromType('connStrip')]}
			disabled={this.state[this.getDisablesState('connStrip')]}
			value={this.state[this.getFilterFromType('connStrip')]}
			onBlur={this[this.getBlurFromType('connStrip')]}
		/>)

		elements.push(<div key={'horizontal' + elements.length}>
		<span className={styles.connStripInfo}
					onPointerEnter={() => this.setState({showAdditionConnStripInfo: true})}
					onPointerLeave={() => this.setState({showAdditionConnStripInfo: false})}>&#63;</span>
			{this.state.showAdditionConnStripInfo
				&& <span className={styles.showConnStrip}>
						Расстояние от здания до контура заземления — это расстояние от контура до стены здания (1-10 метров) +
				Глубина заложения горизонтальной полосы (0,7-1 метр). Данное значение вводится только для одной
				точки присоединения к контуру</span>}
		</div>)

		return elements
	}

	lineHorFilters() {

		let elements = [];

		elements.push(<DropDown
			x={715}
			y={505}
			title='Сечение, мм:'
			key={'lineHor' + elements.length}
			onChange={this[this.getChangeFromType('lineSection')]}
			disabled={this.state[this.getDisablesState('lineSection')]}
			value={this.state[this.getFilterFromType('lineSection')]}
			options={this.state[this.getOptionsFromType('lineSection')]}
		/>)

		elements.push(<DropDown
			x={715}
			y={565}
			title='Материал:'
			key={'lineHor' + elements.length}
			onChange={this[this.getChangeFromType('lineMaterial')]}
			disabled={this.state[this.getDisablesState('lineMaterial')]}
			value={this.state[this.getFilterFromType('lineMaterial')]}
			options={this.state[this.getOptionsFromType('lineMaterial')]}
		/>)

		elements.push(<Input
			key={'position' + elements.length}
			x={420}
			y={625}
			title='Количество точек присоеиняется к контуру'
			type = 'number'
			min={this.state.pointNumMin}
			max={999}
			step={1}
			onBlur={this[this.getBlurFromType('pointNum')]}
			onChange={this[this.getChangeFromType('pointNum')]}
			disabled={this.state[this.getDisablesState('pointNum')]}
			value={this.state[this.getFilterFromType('pointNum')]}
		/>)

		elements.push(this.state.mz && <div key={'position' + elements.length}>
		<span className={styles.pointsInfo}
					onPointerEnter={() => this.setState({showAdditionVoltInfo: true})}
					onPointerLeave={() => this.setState({showAdditionVoltInfo: false})}>&#63;</span>
			{this.state.showAdditionVoltInfo
				&& <span className={styles.showPointsInfo}>
						Количество точек присоединения к контуру соответствует количеству опусков токоотвода.
							Согласно СО 153-34.21.122-2003 расстояние между токоотводами должно быть не более 20 метров</span>}
		</div>)

		return elements
	}

	infoInput(){
		let elements = [];

		elements.push(<TextAreaInput
			key={'info' + elements.length}
			x={20}
			y={10}
			width={310}
			rows={2}
			title='Название объекта'
			onChange={this[this.getChangeFromType('name')]}
			disabled={false}
			value={this.state[this.getFilterFromType('name')]}
		/>)

		elements.push(<Input
			key={'info' + elements.length}
			x={20}
			y={90}
			width={310}
			title='Автор проекта'
			onChange={this[this.getChangeFromType('author')]}
			disabled={false}
			value={this.state[this.getFilterFromType('author')]}
		/>)

		elements.push(<TextAreaInput
			key={'info' + elements.length}
			x={20}
			y={140}
			width={310}
			rows={2}
			title='Адрес объекта'
			onChange={this[this.getChangeFromType('address')]}
			disabled={false}
			value={this.state[this.getFilterFromType('address')]}
		/>)

		elements.push(<ImageInput
			key={'info' + elements.length}
			title={'Выберите изображение объекта (.jpg, .jpeg, .png)'}
			x={20}
			y={220}
			onChange={this[this.getChangeFromType('projectImg')]}
			onInput={this[this.getChangeFromType('projectImg')]}
		/>)

		elements.push(<TextAreaInput
			key={'info' + elements.length}
			x={20}
			y={270}
			width={310}
			title='Описание'
			onChange={this[this.getChangeFromType('desc')]}
			disabled={false}
			value={this.state[this.getFilterFromType('desc')]}
		/>)

		elements.push(
			<div style={{
				top: '400px',
				width: '140px'
			}}
					 key={'info' + elements.length}
					 className={styles.selectBlank}
			/>
		)

		return elements
	}

// -- Рендер


	// ++ Обработка печати
	doPrint(params) {
		let _params = params || {};
		_params.data = {
			specList: JSON.stringify(this.state.specList)
		};
		super.doPrint(_params);
	}

	onBtnSaveClick(){
		if (!(this.state.listForPrint.length && this.state.viewSect === 'result')) {
			this.showWarning('Для составления отчета нужно составить спецификацию и перейти в панель "Результат"')
		}
	}
	// -- Обработка печати

	// Рендер
	render() {
		let countBGColor = this.state.viewSect === 'count' ? '#fff' : '#dcdcdc'
		let resultBGColor = this.state.viewSect === 'result' ? '#fff' : '#dcdcdc'
		return (
			<div className={styles.cfg}>

				{
					this.state.showWarn
						?
						<Popup
							warningText={this.state.warningText}
							onClick={this.clickAwayHandler}
						/>
						:
						null
				}

				{/*Белый фон и лого*/}
				<div style={{position: 'absolute', margin: '0 auto', backgroundColor: '#fff', width: '10%', height: '80px'}}/>
				<Image
					className={styles.logo}
					blockChangeScale={true}
				/>
				{/*Оранжевый фон заголовка*/}
				<div style={{margin: '0 auto', backgroundColor: '#ffcc3f', width: '100%', height: '80px'}}>
					<div className={styles.title}>Подбор оборудования заземления</div>
				</div>

				{/*Табы для переключения видом*/}
				<div
					key={'view'}
					style={{position: 'absolute', top: '100px', left: "400px"}}>
					<span
						onClick={this.viewSecCount}
						style={{background: countBGColor, cursor:'pointer'}}
						className={styles.countSectionTitle + ' ' + 'activeTab'}>Ввод Данных</span>
					<span
						onClick={this.viewSecResult}
						style={{background: resultBGColor, cursor:'pointer'}}
						className={styles.resultSectionTitle + ' ' + 'activeTab'}>Результат</span>
				</div>
				{/*Расчеты*/}
				{
					this.state.viewSect === 'count' &&
						<div>
							{/*Левая Часть*/}
							<div style={{
								position:'relative',
								left: '20px',
								top: '20px',
								width: '360px',
								height: '40px',
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
								backgroundColor: '#fff',
							}}>
								<div className={styles.AddSectionTitle}>Данные объекта</div>
							</div>
							{/*Поля вывода*/}
							<div style={{
								position:'relative',
								left: '20px',
								top: '20px',
								width: '360px',
								height: '290px',
								backgroundColor: '#fff',
								overflowY:'scroll',
							}}>

								{this.infoInput ? this.infoInput() : null}
							</div>

							{/* Фото */}
							<Image
								className={styles.itemImgCount}
								blockChangeScale={false}
							/>

							{/*Правая часть*/}
							<div style={{
								width: '980px',
								height: '530px',
								left: '400px',
								top: '160px',
								position: 'absolute',
								margin: '0 auto',
								backgroundColor: '#fff'
							}}/>


							{this.addBlock ? this.addBlock() : null}
						</div>
				}

				{
					this.state.viewSect === 'result' ?

						this.state.showLoader ?
							<div>
								<svg className={styles.preloader__image} role="img" xmlns="http://www.w3.org/2000/svg"
										 viewBox="0 0 512 512">
									<path fill="currentColor"
												d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z">
									</path>
								</svg>
							</div>
							:
							<div>
						<span
							style={{top: '100px', left: '20px', width: '400px', position: 'absolute'}}
						>
							* - на 1 вертикальный заземлитель приходится 1,5 метра изоляционной ленты
						</span>

								<span
									style={{top: '130px', left: '20px', width: '400px', position: 'absolute'}}
								>
							* - на 1 вертикальный заземлитель приходится 0,01 литра токопроводящей базы
						</span>

								{/*Список*/}


								<TableComponent
									title='Аксессуары'
									type='NoBucket'
									items={this.state.itemList}
									styles={{width: '360px', height: '470px', top: '170px', left: '20px', fontSize: '12px'}}
									onSelect={this.onListItemCheck}
									addBasket={this.addBasket}
									itemInfo={this.state.itemInfo}
									configType={this.getType()}
									color='#ffcc3f'
								/>


								{/*Середина*/}
								{/*Спецификация*/}
								<TableComponent
									title='Спецификация'
									type='Bucket'
									items={this.state.specList}
									styles={{width: '520px', height: '480px', top: '160px', left: '400px', fontSize: '12px'}}
									onSelect={this.onListItemCheck}
									onDelete={this.onDelete}
									onChangeQuantity={this.onChangeQuantity}
									color='#ffcc3f'
									configType={this.getType()}
								/>


								{/*Правая часть*/}
								{/* Артикул и имя */}
								<div className={styles.itemInfoBG}/>
								{this.state.itemInfo && this.state.itemInfo[0] ? (
									<a
										href={`https://www.iek.ru/products/catalog/?page=detail&article=${this.state.itemInfo[0] && this.state.itemInfo[0].art}`}
										target="_blank">
										<div className={styles.itemInfo}>
											<div
												className={styles.itemInfo_Article}>{this.state.itemInfo && this.state.itemInfo[0] && this.state.itemInfo[0].art}</div>
											<div>{this.state.itemInfo && this.state.itemInfo[0] && this.state.itemInfo[0].name}</div>
										</div>
									</a>
								) : (
									<div className={styles.itemInfoNoArticle}/>
								)}

								{/* Фото */}
								<Image
									className={styles.itemImg + ' ' +
										(this.state.itemInfo && this.state.itemInfo.length === 0 ? styles.warn : '')}
									url={this.state.itemInfo && this.state.itemInfo[0] && this.state.itemInfo[0].ImgPng && this.state.itemInfo[0].ImgPng[0].file_ref.uri ? this.state.itemInfo[0].ImgPng[0].file_ref.uri : null}
								/>

								{/* Описание */}
								<div style={{
									position: 'absolute',
									top: '452px',
									left: '940px',
									backgroundColor: '#fff',
									width: '434px',
									height: '232px'
								}}/>
								{this.state.itemInfo && this.state.itemInfo[0] && this.state.itemInfo[0].Description[0].desc_ru ? (
									<div className={styles.description}>
										{this.state.itemInfo[0].Description[0].desc_ru}
									</div>
								) : this.state.itemInfo && this.state.itemInfo.length === 0 ? (
										<div className={styles.description}>
											На сайте временно веутся технические работы. Некоторые данные могут быть недоступны
										</div>
									)
									: (
										<div className={styles.descriptionEmpty}>
										</div>
									)}

							</div>


					: null
				}



				{/*Кнопки*/}
				{this.getCustomButtons ? this.getCustomButtons() : null}

				{/*Нижняя плашка*/}
				{/* На основной сайт IEK */}
				<div style={{position: 'absolute', backgroundColor: '#ffffff', width: '50%', height: '20px', top: '760px'}}/>
				<a className={styles.homeLink} href={'https://www.iek.ru/'} target="_blank">На основной сайт IEK</a>
				<span className={styles.feedBack}>Почта для связи: kiselevav@iek.ru</span>
				<div style={{
					position: 'absolute',
					top: '765px',
					left: '1350px',
					zIndex: '15'
				}}>
					<GroundLightVersion />
				</div>
				{/* Техническая поддержка */}
				<div style={{
					position: 'absolute',
					backgroundColor: '#ffcc3f',
					width: '50%',
					height: '20px',
					top: '760px',
					left: '50%'
				}}/>
				<a style={{
					position: 'absolute',
					top: '763px',
					left: '415px',
					color: '#3c4e50',
					width: '141px',
					height: '14px'
				}} href={'https://www.iek.ru/support/techsupport/'} target="_blank">Техническая поддержка:
				</a>
				<span className={styles.techSupport}>+7 (495) 542-22-27</span>

			</div>)
	}

}

export default GroundSelectionConfigurator;



// WEBPACK FOOTER //
// ./src/react/GroundSelectionConfigurator.jsx